import { Asterisk } from "lucide-react";

const words = ["Generative AI", "LLM Applications", "Data Engineering", "Custom ML", "Analytics", "Agentic Automation", "AI Consulting", "Chatbots"];

export const Marquee = () => (
  <section data-testid="marquee-ribbon" className="relative -rotate-[1.5deg] overflow-hidden border-y-2 border-ink bg-amber py-5 sm:py-7">
    <div className="marquee-track flex w-max">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
          {words.map((w, i) => (
            <span key={w} className="flex items-center">
              <span className={`px-6 font-display text-4xl text-ink sm:text-6xl ${i % 2 ? "italic" : ""}`}>{w}</span>
              <Asterisk className="h-8 w-8 text-ink sm:h-10 sm:w-10" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
